import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './EditorControls.theme.scss';

function EditorControls({ onCancel, onClear, onSynthesise, isEmptyEditor, hasProjects, isLoading, isValidationError }) {
  return (
    <section className="retro-synthesis-editor-controls">
      <Button
        disabled={isEmptyEditor}
        onClick={onClear}
        buttonConfig={{
          className: 'retro-synthesis-editor-controls__button retro-synthesis-editor-controls__button--clear',
          label: 'Clear',
          type: 'link',
          size: 'sm',
          e2eName: 'draw-structure-clear',
        }}
        iconConfig={{
          name: 'trash',
        }}
      />

      <Button
        onClick={onCancel}
        disabled={!hasProjects}
        buttonConfig={{
          className: 'retro-synthesis-editor-controls__button',
          label: 'Cancel',
          type: 'tertiary',
          size: 'sm',
          e2eName: 'draw-structure-cancel',
        }}
        iconConfig={{
          name: 'delete',
          size: 'tiny',
        }}
      />

      <Button
        disabled={isEmptyEditor || isLoading || isValidationError}
        onClick={onSynthesise}
        buttonConfig={{
          className: 'retro-synthesis-editor-controls__button',
          label: 'Synthesize',
          type: 'primary',
          size: 'sm',
          e2eName: 'draw-structure-synthesize',
        }}
        iconConfig={{
          name: 'chevron-right',
        }}
      />
    </section>
  );
}

EditorControls.defaultProps = {
  onCancel: () => null,
  onClear: () => null,
  onSynthesise: () => null,
  isValidationError: false,
};

EditorControls.propTypes = {
  onCancel: PropTypes.func,
  onClear: PropTypes.func,
  onSynthesise: PropTypes.func,
  hasProjects: PropTypes.bool,
  isEmptyEditor: PropTypes.bool,
  isLoading: PropTypes.bool,
  isValidationError: PropTypes.bool,
};

export default EditorControls;
